module.exports = __webpack_public_path__ + "static/media/Informationicon01@2x.903a0223.png";